import { Query } from '@/_core/cqrs/types/queries';

export class GetUserStatisticsQuery extends Query<IGetUserStatisticsQueryResult> {
    constructor() {
        super('GetUserStatisticsQuery');
    }
}

export interface IGetUserStatisticsQueryResult {
    Id: string;
    ShortId: string;
    IsUserLoggedIn: boolean;
    Name: string;
    Email: string;
    EmailDomain: string;
    IpAddress: string;
    SignedUpAt: Date;
    LoginCount: number;
    SessionId: string;
    NumberOfWorkspacesWhereMember: number;
    HighestGlobalWorkspaceRole: string;
    NumberOfNonTrialWorkspacesWhereMember: number;
    HighestNonTrialWorkspaceRole: string;
    NumberOfStorymapsWhereCollaborator: number;
    HighestGlobalStorymapRole: string;
    IsDomainControlled: boolean;
    IsLoggedInViaSso: boolean;
    IsInWorkspaceContext: boolean;
    OnboardingInfo: IUserOnboardingInfo;
    Workspace: IWorkspaceStatistics;
}

interface IWorkspaceStatistics {
    Id: number;
    Subdomain: string;
    Name: string;
    CreatedAt: Date;
    CreatedBy: string;
    WorkspaceRole: string;
    IsTrial: boolean;
    IsExpiredTrial: boolean;
    SubscriptionPlanId: number;
    SubscriptionSourcePlanId: number;
    SubscriptionPlan: string;
    IsSuspended: boolean;
    SubscriptionEditorCount: number;
    NumberOfMembers: number;
    BillingCountry: string;
}

interface IUserOnboardingInfo {
    Role: string;
    CompanyType: string;
    ProductType: string;
    TeamType: string;
    ProjectManagementTool: string;
    Experience: string;
    Interests: string;
    SharedWith: string;
}
